<template>
  <section class="s-pt-30 s-pb-20 s-pt-xl-60 s-pb-xl-40 c-gutter-60 c-mb-30">
    <div class="container">
      <div
        v-if="isEnableSpecialOffer"
        class="offer-box"
        @click="
          $router.push({
            name: 'category',
            params: { categoryName: 'specialoffer' },
          })
        "
      >
        <span class="offer-text">Special Offer</span>
        <div class="offer-icon" ref="lottieContainer"></div>
      </div>

      <div class="row" id="box">
        <div
          class="col-xl-4 col-lg-6 col-6"
          v-if="
            paymentName == '' ||
            paymentName == ' ' ||
            paymentName == 'mpitesan' ||
            paymentName == 'citizenpay' ||
            paymentName == 'bppay' ||
            paymentName == 'onepay' ||
            paymentName == undefined
          "
        >
          <div
            class="vertical-item text-center service-layout-1 content-padding"
            @click="
              $router.push({
                name: 'category',
                params: { categoryName: 'tarot-shuffle' },
              })
            "
          >
            <div class="item-media">
              <!-- <div class="discount-ribbon">
                <span class="ribbon-text">20% OFF</span>
              </div> -->
              <img :src="displayByPayment[2].image" alt="img" />
            </div>
          </div>
        </div>

        <div
          class="col-xl-4 col-lg-6 col-6"
          v-if="
            paymentName == '' ||
            paymentName == ' ' ||
            paymentName == 'mpitesan' ||
            paymentName == 'citizenpay' ||
            paymentName == 'bppay' ||
            paymentName == 'onepay' ||
            paymentName == undefined
          "
        >
          <div
            class="vertical-item text-center service-layout-1 content-padding"
            @click="
              $router.push({
                name: 'category',
                params: { categoryName: 'compatability-love' },
              })
            "
          >
            <div class="item-media">
              <!-- <div class="discount-ribbon">
                <span class="ribbon-text">20% OFF</span>
              </div> -->
              <img :src="displayByPayment[3].image" alt="img" />
            </div>
          </div>
        </div>
        <div
          class="col-xl-4 col-lg-6 col-6"
          v-if="
            paymentName == '' ||
            paymentName == ' ' ||
            paymentName == 'onepay' ||
            paymentName == 'mpitesan' ||
            paymentName == 'citizenpay' ||
            paymentName == 'bppay' ||
            paymentName == undefined
          "
        >
          <div
            class="vertical-item text-center service-layout-1 content-padding"
            @click="
              $router.push({
                name: 'category',
                params: { categoryName: 'tarot' },
              })
            "
          >
            <div class="item-media">
              <!-- <div class="discount-ribbon">
                <span class="ribbon-text">15% OFF</span>
              </div> -->
              <img :src="displayByPayment[1].image" alt="img" />
            </div>
          </div>
        </div>

        <div
          class="col-xl-4 col-lg-6 col-6"
          v-if="
            paymentName == '' ||
            paymentName == ' ' ||
            paymentName == 'onepay' ||
            paymentName == 'mpitesan' ||
            paymentName == 'bppay' ||
            paymentName == undefined
          "
        >
          <div
            class="vertical-item text-center service-layout-1 content-padding"
            @click="
              $router.push({
                name: 'category',
                params: { categoryName: 'newyearbaydin' },
              })
            "
          >
            <div class="item-media">
              <!-- <div class="discount-ribbon">
                <span class="ribbon-text">50% OFF</span>
              </div> -->
              <img :src="new_year_baydin.image" alt="img" />
            </div>
          </div>
        </div>

        <!-- .col-* -->
        <div
          class="col-xl-4 col-lg-6 col-6"
          v-for="category in displayCategories"
          :key="category.id"
        >
          <div
            class="vertical-item text-center service-layout-1 content-padding"
            @click="
              $router.push({
                name: 'category',
                params: { categoryName: category.name },
              })
            "
          >
            <div class="item-media">
              <!-- <div v-if="[7].includes(category.id)" class="discount-ribbon">
                <span class="ribbon-text">10% OFF</span>
              </div> -->
              <img :src="category.image" alt="img" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import types from "@core/i18n/resource/direct_types.json";
import lottie from "lottie-web";
import animationData from "@/assets/animation.json";
export default {
  name: `Home`,
  data() {
    return {
      types: types,
      paymentName: "",
      new_year_baydin: {
        name: "newyear",
        image: require("@/images/home/newyear.png"),
      },
      categories: {
        love: "အချစ်ဇာတာဟောစာတမ်း",
        child: "အမည်ပေး(ရင်သွေးအမည်)",
        oneyear: "တနစ်စာအဟော",
        business: "အမည်ပေး(လုပ်ငန်းအမည်)",
        direct: "ဗေဒင်ဆရာနဲ့တိုက်ရိုက်မေးမည်",
        phone: "ဗေဒင်ဆရာမှဖုန်းပြန်လည်ခေါ်ဆိုပေးမည်",
        zoom: "zoom",
      },
      isEnableSpecialOffer: true,
      displayByPayment: [
        {
          id: 12,
          name: "nawin",
          image: require("@/images/home/12.png"),
        },
        {
          id: 13,
          name: "tarot",
          image: require("@/images/home/13.png"),
        },
        {
          id: 14,
          name: "tarot shuffle",
          image: require("@/images/home/tarot-shuffle.png"),
        },
        {
          id: 15,
          name: "compatability love",
          image: require("@/images/home/compatability.png"),
        },
      ],

      displayCategories: [
        // {
        //   id: 12,
        //   name: "nawin",
        //   image: require("@/images/home/12.png"),
        // },
        // {
        //   id: 1,
        //   name: "oneyear",
        //   image: require("@/images/home/1.png"),
        // },
        // {
        //   id: 13,
        //   name: "tarot",
        //   image: require("@/images/home/13.jpg"),
        // },
        {
          id: 2,
          name: "clairvoyance",
          image: require("@/images/home/2.png"),
        },
        // {
        //   id: 3,
        //   name: "free",
        //   image: require("@/images/home/3.png"),
        // },
        {
          id: 4,
          name: "chiromancy",
          image: require("@/images/home/4.png"),
        },
        // {
        //   id: 11,
        //   name: "zoom",
        //   image: require("@/images/home/11.png"),
        // },
        {
          id: 5,
          name: "child",
          image: require("@/images/home/5.png"),
        },
        {
          id: 6,
          name: "love",
          image: require("@/images/home/6.png"),
        },
        {
          id: 7,
          name: "phone",
          image: require("@/images/home/7.png"),
        },
        // {
        //   id: 8,
        //   name: "direct",
        //   image: require("@/images/home/8.png"),
        // },
        // {
        //   id: 9,
        //   name: "business",
        //   image: require("@/images/home/9.png"),
        // },
        {
          id: 10,
          name: "orders",
          image: require("@/images/home/10.png"),
        },
        {
          id: 20,
          name: "terms_and_conditions",
          image: require("@/images/home/T_and_C.png"),
        },
        {
          id: 21,
          name: "frequently_ask_question",
          image: require("@/images/home/FAQ.png"),
        },
      ],
      // kbzpay_token: ''
      // orders: [],
    };
  },
  mounted() {
    console.log("Config: Home", this.$configService.config);
    console.log(
      "Config: Home Test Config value ",
      typeof this.$configService.getConfigValue("Specialoffer").value,
    );
    this.isEnableSpecialOffer =
      this.$configService.getConfigValue("Specialoffer").value == "1"
        ? true
        : false;
    // alert('Offer',this.isEnableSpecialOffer)

    lottie.loadAnimation({
      container: this.$refs.lottieContainer,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData,
    });
  },
  computed: {
    ...mapGetters({
      getCategories: "categoryStore/getCategories",
      specialCategories: "categoryStore/getSpecialCategories",
      normalCategories: "categoryStore/getNormalCategories",
      isAuthenticated: "userStore/isAuthenticated",
      getResponse: "userStore/getResponse",
      getUserToken: "userStore/getUserToken",
      kbzToken: "userStore/kbzToken",
    }),
    ...mapState(["kbzToken"]),
  },
  watch: {
    kbzToken(newVal, oldVal) {
      console.log("kbzToken changed from", oldVal, " to ", newVal);
    },
  },
  async created() {
    if (this.kbzToken == null) {
      await this.$store.dispatch("fetchKBZToken");
      console.log("kbz token at Home component: ", this.kbzToken);
    }
    this.paymentName = this.$store.state.paymentName;

    if (
      this.$store.state.paymentName == "mpitesan" ||
      this.$store.state.paymentName == "citizenpay"
    ) {
      this.displayCategories.length = this.displayCategories.length - 1;
    }

    if (this.getCategories.length === 0) {
      this.$store.dispatch("categoryStore/allCategories");
    }
    if (
      this.$store.state.paymentName == " " &&
      this.kbzToken
      // this.$route.query.kbzpay_token &&
    ) {
      if (!this.isAuthenticated) {
        console.log("not authenticated", this.kbzToken);
        await this.$store.dispatch(
          "userStore/login",
          this.kbzToken,
          // this.$route.query.kbzpay_token
        );
      } else {
        console.log("authenticated", this.kbzToken);
        console.log("reponse queryCustInfo", this.getResponse);

        await this.$store.dispatch(
          "userStore/queryCustInfo",
          this.kbzToken,
          // this.$route.query.kbzpay_token
        );

        console.log("kbz token ", this.kbzToken);
      }
    }
  },
};
</script>
<style>
@keyframes premium-shake {
  0% {
    transform: translateX(0);
  }

  20% {
    transform: translateX(-1px);
  }

  40% {
    transform: translateX(1px);
  }

  60% {
    transform: translateX(-1px);
  }

  80% {
    transform: translateX(1px);
  }

  100% {
    transform: translateX(0);
  }
}
</style>
<style scoped>
.container {
  padding-top: 15px !important;
}

.cat {
  font-size: 2em;
}

#box {
  margin: 0 0;
}

.offer-box {
  display: flex;
  align-items: center;
  justify-content: space-around;
  /* background: linear-gradient(to right bottom, #ff416cd6, #ffffff00); */
  /* background: linear-gradient(135deg,#ee0979, #ff6a008c ); */

  /* Before */
  /* background: linear-gradient(135deg,#ee0978ac ); */
  /* Before */

  /* background: linear-gradient(135deg,#ff6a0097 ); */
  /* background: linear-gradient(135deg,#fa9944 ); */
  background: linear-gradient(135deg, #ff758c, #ff7eb3);
  /* background: linear-gradient(135deg, #ed75ff, #ff7eb3); */

  box-shadow:
    0 6px 15px rgba(0, 0, 0, 0.2),
    0 0 10px rgba(255, 118, 180, 0.4);
  border-radius: 20px;
  padding: 0.8rem 0.5rem;
  width: auto;
  /* height: 10%; */
  height: 60px;
  min-height: 40px;

  margin: 0.1rem 2.3rem 0.5rem 2.3rem;
  /* min-height: 60px; */
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15); */
  /* Before */
  /* box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2),
              0 0 12px rgba(255, 105, 180, 0.4);  */
  /* Before premium glow */
  position: relative;
  overflow: hidden;
  /* အစွန်းထွက် or အပိုထွက်နေသည်များကို Hidden */
}

.offer-box::before {
  content: "";
  position: absolute;
  top: 0;
  right: -25%;
  width: 60%;
  height: 100%;
  min-height: 60px;

  background: rgba(255, 255, 255, 0.7);
  /* background: rgba(255, 255, 255, 0.588); */
  transform: skewX(-25deg);
  pointer-events: none;
}

/* .offer-text {
  color: #fff;
  font-size: 1.1rem;
  font-weight: 600;
} */
.offer-text {
  /* color: #fff; */
  color: #fff;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.2px;
  /* font-family: 'Poppins', sans-serif; */
  font-family: "Playfair Display", serif;
  /* text-transform: uppercase; */
}

.offer-icon {
  width: 50px;
  height: 50px;
  min-width: 50px;
  min-height: 50px;
}

@media (min-width: 768px) {
  .offer-icon {
    width: 90px;
    height: 90px;
    min-width: 90px;
    min-height: 90px;
  }

  .offer-box {
    height: 110px;
    margin: auto 3rem;
  }

  .offer-text {
    font-size: 3.5rem;
    font-weight: 900;
    letter-spacing: 3px;
  }

  .container {
    padding-top: 45px !important;
  }
}

.discount-card {
  position: relative;
  overflow: hidden;
}

.discount-ribbon {
  position: absolute;
  top: 14px;
  right: -40px;
  z-index: 10;
  width: 150px;
  height: 36px;
  background: linear-gradient(135deg, #2ecc71, #27ae60);
  transform: rotate(45deg);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
}

.ribbon-text {
  color: #fff;
  font-weight: 800;
  font-size: 0.8rem;
  letter-spacing: 0.8px;
  white-space: nowrap;
  display: inline-block;
  will-change: transform;
  animation: premium-shake 2.2s ease-in-out infinite;
}

/* Responsive */
/* @media (min-width: 768px) {
  .discount-ribbon {
    width: 180px;
    height: 42px;
    top: 18px;
    right: -50px;   
    left: auto;
  }

  .ribbon-text {
    font-size: 0.9rem;
  }
} */
@media (max-width: 480px) {
  .discount-ribbon {
    width: 110px;
    height: 24px;
    top: 8px;
    right: -34px;
  }

  .ribbon-text {
    font-size: 0.6rem;
    letter-spacing: 0.1px;
  }
}

@keyframes ribbon-shake {
  0% {
    --shake-x: 0px;
  }

  10% {
    --shake-x: -2px;
  }

  20% {
    --shake-x: 2px;
  }

  30% {
    --shake-x: -2px;
  }

  40% {
    --shake-x: 2px;
  }

  50% {
    --shake-x: 0px;
  }

  100% {
    --shake-x: 0px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .discount-ribbon {
    animation: none;
  }
}
</style>
